import './styles/index.css';
import React from 'react';
import Router from './app/routes/router';
import ReactDOM from 'react-dom/client';
import store from './middlewares/redux/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Router/>
    </BrowserRouter>
  </Provider>
);
